module.exports = __webpack_public_path__ + "img/sold.4e5311fe.svg";